import { render, staticRenderFns } from "./boxHeader.vue?vue&type=template&id=12d07f24&"
import script from "./boxHeader.vue?vue&type=script&lang=js&"
export * from "./boxHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports